var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29195 17.29L15.592 7H10.952C10.402 7 9.95195 6.55 9.95195 6C9.95195 5.45 10.402 5 10.952 5H16.992C18.102 5 19.002 5.84 19.002 6.88V13C19.002 13.55 18.552 14 18.002 14C17.452 14 17.002 13.55 17.002 13V8.41L6.71195 18.7C6.51195 18.9 6.26195 18.99 6.00195 18.99C5.74195 18.99 5.49195 18.89 5.29195 18.7C4.90195 18.31 4.90195 17.68 5.29195 17.29Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/ArrowUpRight.df65943e12780f32d74466c23fc8c1a1.svg";